import { Column, Label, Row } from "@dgs/core";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
	PaymentTransactionItem,
	PaymentTransactionItemType,
	ShopSummaryTaxWithDisclaimerIndex,
} from "../../../shared/types";
import { Bold } from "../../../shared/ui/Bold";
import { CancellationConditions } from "./CancellationConditions";
import { PaymentTransactionItemPrice } from "./PaymentTransactionItemPrice";

interface Props {
	item: PaymentTransactionItem;
	taxes: ShopSummaryTaxWithDisclaimerIndex[];
	labels?: ReactNode;
}

const Wrapper = styled.div`
	display: grid;
`;

export function PaymentTransactionItemRow({ item, taxes, labels }: Props) {
	const { t } = useTranslation();

	return (
		<Wrapper>
			<Column>
				<Column $gap={1}>
					<Row $rowGap={0}>
						<Bold>{item.name}</Bold>
						{item.type !== PaymentTransactionItemType.FULL_PAYMENT && <Label size="small">{t(item.type)}</Label>}

						{labels}
					</Row>
					<span>{item.description}</span>
				</Column>
				<CancellationConditions item={item} />
			</Column>
			<PaymentTransactionItemPrice item={item} taxes={taxes} />
		</Wrapper>
	);
}
